export default __webpack_public_path__ + "static/media/english-to-romanian-screenshot-03.79dcbcc7.png";